import React from "react";
import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { LogOut, Settings, FileText, Briefcase, Lightbulb, Users, Building2, History, Image, GitBranch, Globe, Home as HomeIcon, BarChart3, Layers, UserCog, Sparkles, Palette, LineChart, Phone, Anchor, Link2, BookOpen, MessageSquare, Film, MapPin, GalleryHorizontal, PenSquare, CalendarRange, Award, Search, BellRing, HelpCircle, LayoutGrid, ShieldCheck, DollarSign, FolderKanban, Send, Zap, Plug, Flag, Map, Inbox } from "lucide-react";

const NAV_ITEMS = [
  { to: "/admin", end: true, label: "Dashboard", icon: HomeIcon },
  { to: "/admin/kv/site", label: "Configurações", icon: Settings, group: "Configurações" },
  { to: "/admin/branding", label: "Marca & Visual", icon: Palette },
  { to: "/admin/analytics", label: "Analytics & Pixels", icon: LineChart },
  { to: "/admin/seo", label: "SEO Global", icon: Search },
  { to: "/admin/popups", label: "Popups por tempo", icon: BellRing },
  { to: "/admin/hero-cases", label: "Hero & Cases Layout", icon: LayoutGrid },
  { to: "/admin/brazil-map", label: "Mapa do Brasil", icon: Map },
  { to: "/admin/international", label: "Atuação Internacional", icon: Flag },
  { to: "/admin/mordomo", label: "Mordomo — Perguntas", icon: HelpCircle },
  { to: "/admin/taxonomies", label: "Taxonomias", icon: Layers },
  { to: "/admin/contact", label: "Contato & Presença", icon: Phone },
  { to: "/admin/contact-extras", label: "Mapa & Fachada", icon: MapPin },
  { to: "/admin/footer", label: "Rodapé", icon: Anchor },
  { to: "/admin/utm", label: "UTM Builder", icon: Link2 },
  { to: "/admin/i18n", label: "Traduções", icon: Globe },
  { to: "/admin/translate-all", label: "Traduzir Tudo (IA)", icon: Sparkles },
  { to: "/admin/kv/stats", label: "Números / Stats", icon: BarChart3 },
  { to: "/admin/timeline", label: "Linha do Tempo", icon: CalendarRange },
  { to: "/admin/timeline-38", label: "Timeline 38 Anos (IA)", icon: Sparkles },
  { to: "/admin/kv/home_sections", label: "Textos da Home", icon: Layers },
  { to: "/admin/we-are", label: "Thumbs We Are PLACES", icon: GalleryHorizontal },
  { to: "/admin/testimonials", label: "Depoimentos", icon: MessageSquare },
  { to: "/admin/sobre", label: "Página Sobre", icon: BookOpen },
  { to: "/admin/sobre-videos", label: "Vídeos da Sobre", icon: Film },
  { to: "/admin/certifications", label: "Certificações", icon: Award },
  { to: "/admin/cases", label: "Cases", icon: Briefcase, group: "Conteúdo" },
  { to: "/admin/insights", label: "Insights", icon: Lightbulb },
  { to: "/admin/insights-config", label: "Config Insights", icon: PenSquare },
  { to: "/admin/landing-pages", label: "Landing Pages", icon: Zap, group: "Campanhas" },
  { to: "/admin/geo-analytics", label: "Geo-SEO Analytics", icon: Map },
  { to: "/admin/authors", label: "Autores (Insights)", icon: PenSquare },
  { to: "/admin/services", label: "Serviços", icon: FileText },
  { to: "/admin/team", label: "Equipe", icon: Users },
  { to: "/admin/founders", label: "Fundadores", icon: Users },
  { to: "/admin/clients", label: "Clientes", icon: Building2 },
  { to: "/admin/history", label: "Histórico", icon: History },
  { to: "/admin/jobs", label: "Vagas (Carreiras)", icon: Briefcase },
  { to: "/admin/careers_videos", label: "Vídeos Carreiras", icon: Film },
  { to: "/admin/careers-config", label: "Config Carreiras", icon: PenSquare },
  { to: "/admin/concierge", label: "Mordomo — Leads", icon: Sparkles, group: "Engajamento" },
  { to: "/admin/chatbot", label: "Chatbot Marina", icon: MessageSquare },
  { to: "/admin/chatbot-leads", label: "Leads do Chatbot", icon: BellRing },
  { to: "/admin/leads", label: "Repositório de Leads", icon: Inbox },
  { to: "/admin/clients-auth", label: "Clientes (Login)", icon: ShieldCheck, group: "Área do Cliente" },
  { to: "/admin/client-products", label: "Produtos Imobiliários", icon: Building2 },
  { to: "/admin/client-campaigns", label: "Campanhas por Produto", icon: FolderKanban },
  { to: "/admin/client-documents", label: "Repositório Docs", icon: FileText },
  { to: "/admin/client-financials", label: "Financeiro", icon: DollarSign },
  { to: "/admin/client-timeline", label: "Linhas do Tempo", icon: CalendarRange },
  { to: "/admin/client-demands", label: "Demandas Recebidas", icon: Send },
  { to: "/admin/client-briefing", label: "Config Briefing", icon: Zap },
  { to: "/admin/client-integrations", label: "Integrações Externas", icon: Plug },
  { to: "/admin/client-nps", label: "Pesquisas NPS", icon: Award },
  { to: "/admin/client-talkie", label: "Pesquisas Talkie", icon: MessageSquare },
  { to: "/admin/client-archive", label: "Arquivo de Entregas", icon: FolderKanban },
  { to: "/admin/media", label: "Mídia", icon: Image, group: "Sistema" },
  { to: "/admin/versions", label: "Versões", icon: GitBranch },
  { to: "/admin/users", label: "Usuários", icon: UserCog },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen theme-dark flex items-center justify-center text-neutral-400">Carregando…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen theme-light flex">
      <aside className="w-64 bg-black text-white flex flex-col fixed inset-y-0 left-0 z-30">
        <div className="p-6 border-b border-white/10">
          <div className="font-display text-2xl tracking-tighter">places<span className="text-accent-orange">.</span></div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500 mt-1">CMS Admin</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2 no-scrollbar">
          {NAV_ITEMS.map((item, idx) => (
            <React.Fragment key={item.to}>
              {item.group && <div className="text-[10px] uppercase tracking-widest text-neutral-600 px-3 mt-4 mb-1">{item.group}</div>}
              <NavLink to={item.to} end={item.end} data-testid={`nav-admin-${item.to.split("/").pop() || "dash"}`}
                className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2 text-sm rounded-md transition ${isActive ? "bg-accent-yellow text-black font-semibold" : "text-neutral-300 hover:bg-white/5"}`}>
                <item.icon className="w-4 h-4" /> {item.label}
              </NavLink>
            </React.Fragment>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="flex items-center gap-2 px-3 py-2 text-xs">
            {user.picture && <img src={user.picture} alt="" className="w-7 h-7 rounded-full" />}
            <div className="flex-1 min-w-0"><div className="truncate font-semibold">{user.name || user.email}</div><div className="text-[10px] text-neutral-500 truncate">{user.email}</div></div>
          </div>
          <button onClick={logout} data-testid="admin-logout" className="w-full mt-2 flex items-center justify-center gap-2 text-xs text-neutral-400 hover:text-white border border-white/10 hover:border-white/30 py-2 rounded-md transition"><LogOut className="w-3 h-3" /> Sair</button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8 max-w-[1400px]">
        <Outlet />
      </main>
    </div>
  );
}
